
import { Symbol } from '../types';

export const parseSymbols = (symbolString: string): Symbol[] => {
  if (!symbolString) return [];
  
  return symbolString.split(',').map(s => ({
    ticker: s.trim(),
    symbol: s.trim(), // Add symbol field for compatibility
    direction: 'long' as const,
    weight: 1
  }));
};

export const convertToSymbols = (data: any[]): Symbol[] => {
  if (!data || !Array.isArray(data)) return [];
  
  return data.map(item => ({
    ticker: item.symbol || item.name || '',
    symbol: item.symbol || item.name || '',
    direction: item.direction || 'long',
    weight: item.weight || 1
  }));
};

export const convertSymbolsToString = (symbols: Symbol[]): string => {
  if (!symbols || !Array.isArray(symbols)) return '';
  
  return symbols.map(s => s.ticker || s.symbol).join(',');
};
